import { useWebsiteCode } from "~/composables";

type mindboxParams = {
  type: string;
  ids: string;
  email?: string;
}

export function useMindbox() {

  const {
    isMe,
    isAu,
    isInt,
    isUs
  } = useWebsiteCode();

  let suffix = '';
  if (isInt.value) suffix = '-en';
  else if (isMe.value) suffix = '-me';
  else if (isAu.value) suffix = '-at';
  else if (isUs.value) suffix = '-us-new';

  const sendEvent = (params: mindboxParams) => {
    const mindbox = window['mindbox'] || null;
    let eventData;

    if (mindbox) {
      switch (params.type) {
        case 'CATEGORY':
          eventData = {
            operation: 'CategoryView',
            data: {
              customer: { email: params.email },
              viewProductCategory: { productCategory: { ids: { togasWebsite: params.ids + suffix }}}
            }
          }
          break;
        case 'PRODUCT':
          eventData = {
            operation: 'ProductView',
            data: {
              customer: { email: params.email },
              viewProduct: { product: { ids: { togasWebsite: params.ids + suffix }}}
            }
          }
          break;
      }

      mindbox("async", eventData);
    }
  };

  return {
    sendEvent,
  }
}

export default useMindbox;
